export const DEFAULT_CURRENCY_CODE = 'USD';
export const DEFAULT_REGION = 'US';

export const URLS = {
  arrowDown: 'https://web-shop-assets.s3.eu-central-1.amazonaws.com/general/arrow-down.png',
};
